import React from "react";
import PropTypes from "prop-types";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";
import CustomeButton from "../../../components/Button/index";
import EmptyDataView from "../../../components/nodataview";
import icon from "../../../assets/images/no-service.png";
import "./entitydashboard.scss";

const LspLinkedContact = ({ entityLsp = [], loading, role }) => {
  return (
    <div className="lsp-card h-full mt-4 border-gray" data-test>
      <div className="flex justify-content-between formgrid grid grid-nogutter">
        <div className="heading-container--linkcontact">
          <h4>Local Teams</h4>
          <p>View and manage the Local Teams connected to this entity.</p>
        </div>
        <div className="w-full">
          {loading ? (
            <DataTable
              value={Array(6).fill({})}
              tableStyle={{ minWidth: "100%" }}
              className="datatable-right-align w-full pt-2"
              data-testid="data-table-form-skeleton"
              rows={6}
            >
              <Column
                header="Registered Name"
                body={<Skeleton data-testid="loading-skeleton" />}
              />
              {!["CUSTOMER", "CUSTOMER_MANAGER"].includes(role) && (
                <Column
                  sortable
                  header="Phone Number"
                  field="phone"
                  body={<Skeleton data-testid="loading-skeleton" />}
                />
              )}
              {!["CUSTOMER", "CUSTOMER_MANAGER"].includes(role) && (
                <Column
                  header="Email"
                  body={<Skeleton data-testid="loading-skeleton" />}
                />
              )}
              <Column
                header="Key Contact"
                body={<Skeleton data-testid="loading-skeleton" />}
              />
              <Column
                header="Services"
                body={<Skeleton data-testid="loading-skeleton" />}
              />
            </DataTable>
          ) : entityLsp?.length > 0 ? (
            <DataTable
              className="datatable-right-align"
              value={entityLsp}
              sortMode="multiple"
              tableStyle={{ minWidth: "50rem" }}
              data-testid="data-table-form"
              paginator={entityLsp?.length > 10}
              rows={10}
              rowsPerPageOptions={[10, 20, 30]}
            >
              <Column
                field="name"
                sortable
                header="Registered Name"
                className="table-col-width"
              />
              {!["CUSTOMER", "CUSTOMER_MANAGER"].includes(role) && (
                <Column
                  sortable
                  header="Phone Number"
                  className="table-col-width"
                  field="phone"
                  body={(rowData) => (
                    <div className="d-flex align-items-center">
                      <span>
                        +{rowData.phone_code} {rowData.phone}
                      </span>
                    </div>
                  )}
                />
              )}
              {!["CUSTOMER", "CUSTOMER_MANAGER"].includes(role) && (
                <Column
                  field="email"
                  sortable
                  header="Email"
                  className="table-col-width"
                />
              )}

              <Column
                sortable
                field="account_manager_name"
                header="Key Contact"
                className="table-col-width"
              />
              <Column
                field="quantity"
                sortable
                header="Services"
                className="table-col-width"
                body={(rowData) => {
                  return rowData.active_services &&
                    rowData.active_services.length > 0 ? (
                    rowData.active_services.map((service, index) => (
                      <p className="m-0" key={index}>
                        {service.name}
                      </p>
                    ))
                  ) : (
                    <p className="m-0">No Active Services</p>
                  );
                }}
              />
            </DataTable>
          ) : (
            <EmptyDataView
              Icon={
                <img
                  className="users-card-icon-img"
                  src={icon}
                  alt="Users Icon"
                />
              }
              Header={"No Local Teams assigned yet"}
              Description={"Let's add your first one"}
            />
          )}
        </div>
      </div>
    </div>
  );
};
LspLinkedContact.propTypes = {
  entityLsp: PropTypes.array,
  loading: PropTypes.bool,
};
export default LspLinkedContact;
